import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RequestDetailsInterface, sessionStatus, SessionType } from '../../features/consultaion-sessions/models/consultant-session';
import { ConsultationSessionsService } from '../../features/consultaion-sessions/services/consultation-sessions.service';

@Component({
  selector: 'app-consultation-session-details',
  templateUrl: './consultation-session-details.component.html',
  styles: ``
})
export class ConsultationSessionDetailsComponent implements OnInit {
  @Input() selectedSessionId!: string;
  dataLoading = false;
  @Output() close = new EventEmitter<boolean>();
  details!: RequestDetailsInterface;
  isLinear = false;
  session_STATUS = sessionStatus;
  Session_TYPE = SessionType;
  constructor(private service: ConsultationSessionsService) { }

  ngOnInit(): void {
    this.getRequestDetailes();
  }

  getRequestDetailes() {
    this.dataLoading = true;
    this.service.GetRequestDetails(this.selectedSessionId).subscribe({
      next: (response) => {
        this.dataLoading = false;
        this.details = response as RequestDetailsInterface;
      },
      error: (err) => {
        this.dataLoading = false;
      }
    })
  }


}
